import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { AppBar, Toolbar, Box } from "@mui/material";
import Logo from "../Logo";
import SelectLanguage from "../SelectLanguage";
import TopBarMenuItems from "../TopBarMenuItems";

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    marginBottom: theme.spacing(2),
  },

  logoContainer: {
    marginTop: theme.spacing(3),
  },
}));

const TopBar = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <AppBar
      position="static"
      className={classes.appBar}
      style={{
        backgroundColor: "#f5974e",
      }}
    >
      <Toolbar>
        <Box className={classes.logoContainer}>
          <Logo />
        </Box>
        <Box flexGrow={1} />
        <SelectLanguage />
      </Toolbar>
      <Box display="flex" justifyContent="flex-end">
        <TopBarMenuItems />
      </Box>
    </AppBar>
  );
};

export default TopBar;
